import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardCompleteStepTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardCompleteStepTemplate';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useHistory } from 'react-router-dom';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import useMobileLayout from 'Hooks/useMobileLayout';
import Content from './Content';

const styles = (theme) => ({
  root: {},
  navMargin: {
    marginLeft: theme.spacing(10),
  },
});
const AnnualInvestmentReviewCompleteTemplate = ({
  className,
  classes,
  resource,
}) => {
  const { loadHousehold: refreshHousehold } = useSimpleHousehold();
  const history = useHistory();
  const { loadPageContentLink } = usePageContentContext();
  const previousLink = resource.relationship(fr.relationships.previousLink.name)?.link('related');
  const onPrevious = previousLink ? () => loadPageContentLink(previousLink) : undefined;
  const isMobile = useMobileLayout();

  useComponentDidMount(async () => {
    await refreshHousehold();
  });

  return (
    <WizardCompleteStepTemplate
      className={classNames(className, classes.root, { [classes.navMargin]: !isMobile })}
      content={Content}
      resource={resource}
      metaOverrideSet={BaseOverride}
      onPrevious={onPrevious}
      onNext={() => history.push('/')}
    />
  );
};

AnnualInvestmentReviewCompleteTemplate.defaultProps = {
  className: '',
};

AnnualInvestmentReviewCompleteTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(AnnualInvestmentReviewCompleteTemplate);
